import styled from 'styled-components';

export const Background = styled.div`
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    z-index: 10;
    background-color: rgba(0,0,0,0.55);
`;

export const ModalBackground = styled.div`
    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;
    padding: ${({ padding }) => padding}px;
    border-radius: ${({ borderRadius }) => borderRadius}px;
    display: flex;
    background-color: ${({ backgroundColor }) => backgroundColor};
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
    position: absolute;
    top: calc(50% - ${({ height }) => height / 2}px);
    right: calc(50% - ${({ width }) => width / 2}px);
    -webkit-box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
    -moz-box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
    box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
`;
